(ns web3.components.badge
  (:require [web3.constants :as constants]
            [web3.view :as v]))

(def ^:private style {:display          :inline-block
                      :line-height      1
                      :white-space      :no-wrap
                      :color            (:dark-gray constants/colors)
                      :background-color (:light-gray constants/colors)
                      :border-radius    "10rem"
                      :padding          ".15em .5em"})

(defn badge
  ([text]
   [:div {:style style} text])
  ([props text]
   [:div (v/merge-props {:style style}
                        props) text]))

(defn recalled-badge
  []
  [badge {:style {:background-color (:red constants/colors)
                  :padding          "0.15em 0.53em"}
          :class "text-white weight-bold"}
   "!"])

(defn error-badge
  []
  [badge {:style {:background-color (:yellow constants/colors)}
          :class "text-white weight-bold"}
   "?"])



